module.exports = __webpack_public_path__ + "static/media/1 Hyundai Naamkaran.9f683732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/1 Hyundai Naamkaran.jpg
// module id = 159
// module chunks = 0